import React, { useCallback, useState } from "react";
import { Accordion } from "@gcs/design-system/react";
import PropTypes from "prop-types";

import useWindowSize from "../../../hooks/useWindowSize";

import * as S from "./Tabs.style";

const Tabs = ({ defaultIndex, variant, tabs }) => {
  const [currentTab, setCurrentTab] = useState(defaultIndex ?? 0);
  const { width } = useWindowSize();
  const isMobile = width && width <= 992;

  const handleClickTabsTrigger = useCallback((tabIndex) => {
    setCurrentTab(tabIndex);
  }, []);

  const handleAccordionChange = (index) => {
    const currentContent = document.getElementById(`${index}`);

    if (currentContent) {
      setTimeout(() => {
        const offset = 140;

        const top =
          currentContent.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
          top,
          behavior: "smooth",
        });
      }, 500);
    }
  };

  return (
    <S.TabsContainer>
      {!isMobile && (
        <S.TabsList $variant={variant}>
          {Array?.isArray(tabs) &&
            tabs.map((tabItem, index) => (
              <S.TabsTrigger
                id={`tab-${index}-header`}
                key={`tab-${index}-header`}
                type="button"
                $variant={variant}
                $isActiveTab={currentTab === index}
                onClick={() => handleClickTabsTrigger(index)}
              >
                {tabItem?.title}
              </S.TabsTrigger>
            ))}
        </S.TabsList>
      )}

      {!isMobile ? (
        tabs?.[currentTab]?.content && tabs[currentTab].content
      ) : (
        <Accordion onChange={handleAccordionChange}>
          {tabs.map((tab, index) => (
            <S.TabsAccordion title={tab.title} key={tab.title}>
              <S.TabsAccordionContent id={index}>
                {tab?.content ? tab.content : null}
              </S.TabsAccordionContent>
            </S.TabsAccordion>
          ))}
        </Accordion>
      )}
    </S.TabsContainer>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
    })
  ).isRequired,
  defaultIndex: PropTypes.number,
  variant: PropTypes.string,
};

Tabs.defaultProps = {
  defaultIndex: 0,
  variant: "primary",
};

export default Tabs;
